<ng-template #templatePortalContent>
    <div class="eui-popover eui-popover--{{ positionClass }} {{ statesClass }}">
        <div class="eui-popover__arrow">
            <div class="eui-popover__arrow-inner"></div>
        </div>
        <div *ngIf="title" class="eui-popover__header">
            <div class="eui-popover__header-title">{{ title }}</div>
            <div class="eui-popover__header-close" *ngIf="hasCloseButton" (click)="closePopover()">
                <i class="eui-icon eui-icon-ecl-close"></i>
            </div>
        </div>
        <div class="eui-popover__content">
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>
